import React from 'react';

export function Input({ isDarkMode = false, className = '', ...props }) {
  return (
    <input
      className={`flex-grow border ${
        isDarkMode ? 'border-gray-600 bg-gray-700 text-white' : 'border-gray-300 bg-white text-gray-900'
      } focus:border-blue-500 focus:ring-2 focus:ring-blue-500 rounded-md ${className}`}
      {...props}
    />
  );
}